// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"d1b110b3","787":"c7809ba6"}[chunkId] + ".chunk.js";
};